<div id="street-view-message">
    <span *ngIf="!found">No Street View image available for this location</span>
</div>
<div #streetView id="street-view"></div>
<slot name="widget-group"></slot>